<template>
  <div>
     <!-- 回复内容表单 -->
      <el-form ref="DetailForm" :model="DetailForm" style="margin-top:10px;margin-bottom:60px;">
        
          <el-row type="flex" class="row-bg">
            <el-col :span="7">
                <el-form-item label="访客昵称" prop="user_nickname" label-width="120px">
                  <el-input style="width:16em" v-model="DetailForm.user_nickname" readonly></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="7">
                <el-form-item label="联系方式" prop="s_contact" label-width="120px">
                  <el-input style="width:16em" v-model="DetailForm.s_contact" readonly></el-input>
                </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex" class="row-bg">
              <el-col :span="7">
                <el-form-item label="反馈时间" prop="s_createtime" label-width="120px">
                  <el-date-picker
                    type="datetime"
                    value-format="timestamp"
                    v-model="DetailForm.s_createtime"
                    style="width:16em"
                    placeholder="反馈时间"
                    readonly>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7"> 
                <el-form-item label="反馈类型" prop="s_type" label-width="120px">
                    <el-select v-model="DetailForm.s_type" placeholder="反馈类型" style="width:16em" auto-complete="off" disabled>
                        <el-option v-for="item in searchTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
          </el-row>


          <el-row type="flex" class="row-bg">
              <el-col :span="14">
                  <el-form-item label="反馈内容" prop="s_content" label-width="120px">
                      <el-input type="textarea" :rows="4" style="width:100%" v-model="DetailForm.s_content" readonly>
                      </el-input>
                  </el-form-item>
              </el-col>
          </el-row>

          <!-- <el-row type="flex" class="row-bg">
              <el-col :span="14">
                  <el-form-item label="图片" prop="s_img" label-width="120px">
                    <el-upload
                        disabled
                        :class="{disabled:uploadDisabled}"
                        :limit="10"
                        :action="DetailUploadUrl "
                        list-type="picture-card"
                        :on-preview="handleDetailPreview"
                        :file-list="DetailUploadFileList">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <p style="margin:0;color:#41b883;font-size:12px;">图片格式：".bmp", ".jpg", ".jpeg", ".png"</p>
                    <el-dialog :visible.sync="DetailPreviewDialogVisible">
                        <img width="100%" :src="DetailPreviewDialogImageUrl" alt="">
                    </el-dialog>
                  </el-form-item>
              </el-col>
          </el-row> -->

        <!-- <div class="el-row-line"></div> -->

        <el-row type="flex" class="row-bg">
          <el-col :span="14">
              <el-form-item label="回复内容" prop="s_reply" label-width="120px">
                  <el-input type="textarea" :rows="4" style="width:100%" v-model="DetailForm.s_reply" maxlength="400" readonly>
                  </el-input>
                  <span style="color:red">* 最多可输入400个字</span>
              </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg">
          <el-col :span="7">
              <el-form-item label="回复人" prop="reply_name" label-width="120px">
                <el-input style="width:16em" v-model="DetailForm.reply_name" readonly></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="7">
              <el-form-item label="回复时间" prop="s_replytime" label-width="120px">
                <el-input style="width:16em" v-model="DetailForm.s_replytime" readonly></el-input>
              </el-form-item>
          </el-col>
        </el-row>

        <el-footer>
          <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
        </el-footer>
      </el-form>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

// 时间过滤器
import {formatDate} from '@/filter/date.js';
export default {
  name: 'objectionDetail',
  data() {
      return {
          DetailForm:{
            s_id:'',
            s_createtime:'',
          },
          DetailUploadUrl : `${api.dev}/p/suggestion/objection/uploadFile?access_token=${getToken()}`, // 上传图片路径
          DetailUploadFileList : [],
          DetailPreviewDialogVisible : false,
          DetailPreviewDialogImageUrl : '',

          searchTypeList : [
            {
              value: '1',
              label: '稿文申诉'
            },{
              value: '2',
              label: '作品申诉'
            },{
              value: '3',
              label: '意见建议'
            },{
              value: '4',
              label: '文章纠错'
            },{
              value: '5',
              label: '内容纠错'
            }
          ],
          value: '',

      }
  },
  methods : {
    getInfo() {
          this.$http.get(`${api.dev}/p/main/suggestion/select`,{params : {access_token : getToken(), s_id : this.$route.params.id}}).then(res => {
            if(res.body.code == 200) {
              this.DetailForm = res.body.content;
              this.DetailForm.s_id = res.body.content.s_id;
              if(res.body.content.user_nickname == undefined){
                this.DetailForm.user_nickname = "匿名";
                this.DetailForm.s_contact = res.body.content.s_contact;
              }else{
                this.DetailForm.user_nickname = res.body.content.user_nickname;
                this.DetailForm.s_contact = res.body.content.user_phone;
              }
              res.body.content.s_createtime = (res.body.content.s_createtime) ? res.body.content.s_createtime : '';
              
              // if(res.body.content.s_type == "1"){
              //   res.body.content.s_type = "稿文申诉";
              // }else if(res.body.content.s_type == "2"){
              //   res.body.content.s_type = "作品申诉";
              // }else if(res.body.content.s_type == "3"){
              //   res.body.content.s_type = "意见建议";
              // }else if(res.body.content.s_type == "4"){
              //   res.body.content.s_type = "文章纠错";
              // }else if(res.body.content.s_type == "5"){
              //   res.body.content.s_type = "内容纠错";
              // }
              this.DetailForm.s_type = res.body.content.s_type;
              this.DetailForm.s_content = res.body.content.s_content;
              if(this.DetailForm.s_img.length > 0){
                for(var i=0;i<this.DetailForm.s_img.length;i++){
                  this.DetailUploadFileList.push({url : `${api.address}${this.DetailForm.s_img[i]}`})
                }
              }
              this.DetailForm.s_content = res.body.content.s_content;

              this.DetailForm.reply_name = res.body.content.reply_name;
              if(res.body.content.s_replytime != null){
                this.DetailForm.s_replytime = formatDate(new Date(res.body.content.s_replytime),'yyyy-MM-dd hh:mm:ss');
              }
            }else if(res.body.code == 500) {
              this.$message({
                message: res.body.msg,
                type: 'error'
              });
              removeToken();
              setTimeout(function () {
                this.$router.push({path: '/login'});
              },2000)
            }
          })

    },



    // 放大图片
    handleDetailPreview(file) {
        this.DetailPreviewDialogVisible = true;
        this.DetailPreviewDialogImageUrl  = file.url;
    },

    // 返回
    goBack() {
        this.$router.back(-1);
    },


  },
  created() {
    this.getInfo();
  },
  computed: {
      uploadDisabled:function() {
          return this.DetailForm.s_img != '' && this.DetailForm.s_img != null
      },
  },
}
</script>

<style lang="stylus" scoped>
.margin-bottom-10
  margin-bottom 10px
.padding-right-12
  padding-right 12px
/*.el-row-line
  margin:10px 0;
  width:100%;
  height:1px;
  background-color:#ccc;*/
.el-footer
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999;
    margin-left -15px;


</style>
